import ScanID from './ScanID.jsx';

export default ScanID;